// extracted by mini-css-extract-plugin
export default {"wrapper":"Oca-z","boldPrefix":"Pca-z","link":"Qca-z","message":"Rca-z","image":"Sca-z"};